var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThreeDots({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 4,
    viewBox: "0 0 14 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.00171 0.912109C6.41983 0.912109 5.96875 1.41773 5.96875 2.00343C5.96875 2.58491 6.41985 3.08859 7.00171 3.08859C7.58023 3.08859 8.03461 2.58773 8.03461 2.00343C8.03461 1.41499 7.58023 0.912109 7.00171 0.912109Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.35327 0.912109C0.771393 0.912109 0.320312 1.41773 0.320312 2.00343C0.320312 2.58491 0.771413 3.08859 1.35327 3.08859C1.93179 3.08859 2.38617 2.58773 2.38617 2.00343C2.38617 1.41499 1.93179 0.912109 1.35327 0.912109Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6501 0.912109C12.0683 0.912109 11.6172 1.41773 11.6172 2.00343C11.6172 2.58491 12.0683 3.08859 12.6501 3.08859C13.2287 3.08859 13.683 2.58773 13.683 2.00343C13.683 1.41499 13.2287 0.912109 12.6501 0.912109Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDots);
export default __webpack_public_path__ + "static/media/ThreeDots.80e56012f0704560285ecc803107a05e.svg";
export { ForwardRef as ReactComponent };